module.exports = __webpack_public_path__ + "static/media/moduleSet_i4o1.b99576ff.jpg";